import { useAppSelector } from '@shared/hooks/redux';
import { BreadcrumbItemType } from '@shared/types/global';
import { Breadcrumbs } from '@shared/ui/Breadcrumbs';
import { Container } from '@shared/ui/Container';
import { JsonLd } from '@shared/ui/JsonLd/JsonLd';
import { HStack } from '@shared/ui/Stack';
import { getInflectedWord } from '@shared/utils/getInflectedWord/getInflectedWord';
import { ucFirst } from '@shared/utils/ucFirst/ucFirst';

import { Sorting } from '../Sorting/Sorting';
import cls from './Top.module.scss';

type TopProps = {
  breadcrumbs: BreadcrumbItemType[];
  categoryTitle: string;
};

export const Top = ({ breadcrumbs, categoryTitle }: TopProps) => {
  const total = useAppSelector((state) => state.category.pagination.total);

  return (
    <>
      <div className={cls.wrap}>
        <Container>
          <Breadcrumbs
            className={cls.breadcrumbs}
            data={breadcrumbs}
          />
          <HStack
            align={'end'}
            justify={'between'}
            className={cls.block}
          >
            <div className={cls.head}>
              <h1 className={cls.title}>{ucFirst(categoryTitle)}</h1>
              <div className={cls.subtitle}>
                {total} {getInflectedWord(total, ['товар', 'товара', 'товаров'])}
              </div>
            </div>

            <Sorting />
          </HStack>
        </Container>
      </div>
      <JsonLd
        html={{
          '@type': 'BreadcrumbList',
          itemListElement: breadcrumbs.map((crumb, i) => ({
            '@type': 'ListItem',
            position: i + 1,
            name: crumb.label,
            item: `${process.env.NEXT_PUBLIC_SITE_URL}${crumb.url}`
          }))
        }}
      />
    </>
  );
};
